import { code } from "@spscommerce/utils";
import { DSReactExamples } from "@spscommerce/ds-shared";

export const SpsProductBarExamples: DSReactExamples = {
    basic: {
        label: "Basic",
        description: code`
            <p>Product navigation bar</p>
        `,
        examples: {
            basic: {
                react: code`
                    function DemoComponent() {
                        const navTabs = ["Foo", "Bar", "Baz"];
                        function handleTabChange(newTab: string) {
                            alert(newTab);
                        }

                        return (
                            <SpsProductBar productName="My Product"
                                productLogoSrc="https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg"
                                tabs={navTabs}
                                activeTab="Bar"
                                onTabChange={handleTabChange}
                                fullWidth
                                style={{ position: "relative", zIndex: "auto" }} // display this example in its place instead of at the top
                            ><SpsButton>do the thing</SpsButton></SpsProductBar>
                        );
                    }
                `,
            },
        },
    },
    action: {
        label: "Action",
        examples: {
            basic: {
                react: code`
                    function DemoComponent() {
                        const navTabs = ["Foo", "Bar", "Baz"];
                        function handleTabChange(newTab: string) {
                            alert(newTab);
                        }

                        return (
                            <SpsProductBar productName="My Product"
                                productLogoSrc="https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg"
                                tabs={navTabs}
                                activeTab="Bar"
                                onTabChange={handleTabChange}
                                onProductNameClick={() => console.log("product name clicked")}
                                fullWidth
                                style={{ position: "relative", zIndex: "auto" }} // display this example in its place instead of at the top
                            ><SpsButton>do the thing</SpsButton></SpsProductBar>
                        );
                    }
                `,
            },
        },
    },
    link: {
        label: "Link",
        examples: {
            basic: {
                react: code`
                    function DemoComponent() {
                        const navTabs = ["Foo", "Bar", "Baz"];
                        function handleTabChange(newTab: string) {
                            alert(newTab);
                        }

                        return (
                            <SpsProductBar productName="My Product"
                                productLogoSrc="https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg"
                                productNameHref="https://www.google.com"
                                tabs={navTabs}
                                activeTab="Bar"
                                onTabChange={handleTabChange}
                                fullWidth
                                style={{ position: "relative", zIndex: "auto" }} // display this example in its place instead of at the top
                            ><SpsButton>do the thing</SpsButton></SpsProductBar>
                        );
                    }
                `,
            },
        },
    },
    customTabs: {
        label: "Custom Tabs",
        examples: {
            basic: {
                react: code`
                    function DemoComponent() {
                        const [activeTab, setActiveTab] = useState("Bar");

                        return (
                            <SpsProductBar
                                productName="My Product"
                                productLogoSrc="https://cdn.prod.spsc.io/web/framework/assets/17.08.01/icons/cube/cube.svg"
                                fullWidth
                                style={{ position: "relative", zIndex: "auto" }} // display this example in its place instead of at the top
                            >
                                <SpsProductBarTab
                                    active={activeTab === "Foo"}
                                    onClick={() => {
                                        setActiveTab("Foo");
                                        console.log("Foo!");
                                    }}
                                >
                                    Foo
                                </SpsProductBarTab>
                                <SpsProductBarTab
                                    active={activeTab === "Bar"}
                                    onClick={() => {
                                        setActiveTab("Bar");
                                        console.log("Bar!");
                                    }}
                                >
                                    Bar
                                </SpsProductBarTab>
                                <SpsProductBarTab
                                    active={activeTab === "Baz"}
                                    target="_blank"
                                    href="https://www.google.com"
                                    onClick={() => {
                                        setActiveTab("Baz");
                                    }}
                                >
                                    Baz
                                </SpsProductBarTab>
                                <SpsButton>do the thing</SpsButton>
                            </SpsProductBar>
                        )
                    }
                `,
            },
        },
    },
};
